// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Timer-cls1___3843b0e533f9418fe87{/*!*/}.Timer-cls2___de593cac2a0c0bce8d4{position:absolute;left:0;margin:auto;right:0;text-align:center}.Timer-cls2___de593cac2a0c0bce8d4.Timer-top__cff7fb42052294e6baa4{top:50%}.Timer-cls2___de593cac2a0c0bce8d4.Timer-topBack___67404808a6f1026edd7{top:60%;transform:scaleY(-1)}.Timer-cls2___de593cac2a0c0bce8d4.Timer-bottom___a6e11533c085afe8ec4{top:-50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Timer-cls1___3843b0e533f9418fe87",
	"cls2": "Timer-cls2___de593cac2a0c0bce8d4 Timer-cls1___3843b0e533f9418fe87",
	"top": "Timer-top__cff7fb42052294e6baa4",
	"topBack": "Timer-topBack___67404808a6f1026edd7",
	"bottom": "Timer-bottom___a6e11533c085afe8ec4"
};
export default ___CSS_LOADER_EXPORT___;
